export default __webpack_public_path__ + "static/media/Mark-2-HUD-Targeting (Selector Ring).ec99221a.jpg";